import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";
// month picker input component which handles the input field of month picker
@Component({
  selector: "phx-month-picker-input",
  templateUrl: "./phx-month-picker-input.component.html",
  styleUrls: ["./phx-month-picker-input.component.scss"],
  host: {
    class: 'phx-month-picker-input'
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhxMonthPickerInputComponent { }